import { render } from "./CookieSettings.vue?vue&type=template&id=226e1d0e&scoped=true&ts=true"
import script from "./CookieSettings.vue?vue&type=script&lang=ts"
export * from "./CookieSettings.vue?vue&type=script&lang=ts"

import "./CookieSettings.vue?vue&type=style&index=0&id=226e1d0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226e1d0e"]])

export default __exports__